// metadata/union.ts
var BaseQLUnion = class {
  constructor(_class) {
    this._class = _class;
  }
};
export {
  BaseQLUnion
};
